import { c as _c } from "react/compiler-runtime";
import { Link } from '@/frontend/design-system/actions/Link';
import { QAList, type Question } from '../_components/QAList';
const mentoringQuestions: Question[] = [{
  title: 'Na jakiej platformie odbywają się spotkania z mentorem?',
  content: <>
        Zarówno mentoring jak i zajęcia grupowe odbywają się za pomocą platformy{' '}
        <a href='https://discord.com' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Discord
        </a>
        . Każdy uczeń otrzymuje link do prywatnego serwera, poprzez który świadczymy wszystkie
        usługi naszej firmy.
      </>
}, {
  title: 'Jak mogę zapisać się na pierwszą sesję z mentorem?',
  content: <>
        Najlepiej umówić się{' '}
        <Link href='/bezplatna-konsultacja' className='font-semibold text-algoprimary'>
          bezpłatną konsultację
        </Link>
        . Można również umówić się na spotkanie z mentorem telefonicznie lub mailowo.
      </>
}, {
  title: 'Na czym polega program mentorski?',
  content: <>
        Informacje o tym, czym jest mentoring i jak działają nasze programy znajdziesz na stronie{' '}
        <Link href='/mentoring' className='font-semibold text-algoprimary'>
          mentoringu
        </Link>
        .
      </>
}, {
  title: 'Jakie są koszty programu mentoringowego?',
  content: <>
        Koszty mogą się znacząco różnić w zależności od potrzeb ucznia. Zachęcamy do skorzystania z
        naszego kalkulatora dostępnego na stronie z{' '}
        <Link href='/cennik' className='font-semibold text-algoprimary'>
          cennikiem
        </Link>
        .
      </>
}, {
  title: 'Jak długo trwa program mentorski?',
  content: 'Program mentorski jest subskrypcją i jest płatny raz na 4 tygodnie, raz na 12 tygodni lub raz do roku. Możesz zakończyć subskrypcję w dowolnym momencie, wtedy płatność nie zostanie odnowiona.'
}, {
  title: 'Czy mogę zapisać się na mentoring z dowolnej dziedziny informatyki?',
  content: 'Jeżeli uda nam się znaleźć mentora, który zajmuje się daną dziedziną i ma wolne terminy, to na pewno z przyjemnością Ci pomoże.'
}, {
  title: 'Czy mogę zmienić mentora w trakcie trwania mentoringu?',
  content: <>
        Oczywiście! Jeśli Twój mentoring trwa dłużej niż miesiąc, możesz poprosić o zmianę mentora.
        Wystarczy, że napiszesz do nas, a znajdziemy Ci kogoś, kto lepiej pasuje do Twoich potrzeb.
      </>
}, {
  title: 'Czy zajęcia mentoringowe są nagrywane?',
  content: <>
        Z reguły nagrywamy zajęcia - to pomaga nam kontrolować jakość i zapewnić Tobie możliwość
        powtórzenia treści lekcji. Nagrania są tylko dla Ciebie i naszego zespołu, nie udostępniamy
        ich nikomu innemu. Zgadzając się na mentoring, automatycznie wyrażasz zgodę na nagrywanie.
      </>
}, {
  title: 'Czy mogę zrezygnować z nagrywania zajęć?',
  content: <>
        Oczywiście! Jeśli nie zgadzasz się na nagrywanie zajęć, to wystarczy, że poinformujesz nas o
        tym, a my dostosujemy umowę.
      </>
}, {
  title: 'Czy mogę prosić o usunięcie nagrań?',
  content: <>
        W dowolnym momencie możesz poprosić o usunięcie nagrań, a my jesteśmy zobowiązani do
        spełnienia Twojej prośby w terminie 14 dni od dnia zgłoszenia.
      </>
}, {
  title: 'Czy mogę odwołać zajęcia z mentorem?',
  content: <>
        Jasne! Możesz odwołać lub przełożyć zajęcia, ale daj nam znać najwcześniej jak to możliwe.
        Jeśli odwołasz zajęcia później niż 24 godziny przed ich rozpoczęciem, lub nie przyjdziesz na
        nie, zajęcia mogą zostać uznane za zrealizowane.
      </>
}, {
  title: 'Co jeśli mentor odwoła zajęcia?',
  content: <>
        Czasami zdarza się, że mentor musi odwołać zajęcia z ważnych powodów (choroba, awaria
        sprzętu itp.). W takiej sytuacji poinformujemy Cię mailowo i w wiadomości prywatnej przez
        platformę{' '}
        <a href='https://discord.com' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Discord
        </a>{' '}
        najszybciej jak to możliwe. W takim przypadku przełożymy zajęcia na inny termin lub zwrócimy
        Ci pieniądze w zależności od sytuacji i Twoich preferencji.
      </>
}];
export function QAMentoringSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QAList questions={mentoringQuestions} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}